import { render, staticRenderFns } from "./AuthWithApple.vue?vue&type=template&id=a3504e4a&"
import script from "./AuthWithApple.vue?vue&type=script&lang=js&"
export * from "./AuthWithApple.vue?vue&type=script&lang=js&"
import style0 from "./AuthWithApple.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports